import styles from "../styles/Button.module.scss";

const Button = ({ url, label }) => {
  return (
    <a target="_blank" rel="noreferrer" href={url} className={styles.buttonContainer}>
      <div className={styles.redirectButton}>
        <div>{label.toUpperCase()}</div>
      </div>
    </a>
  );
};

export default Button;
